export default __webpack_public_path__ + "static/media/Q32023.f8829dc9.pdf";